import React from "react";
import { Tooltip } from "@mui/material";
import { InfoRounded } from "@mui/icons-material";

export default function DashboardCardInfo({ title, bottom = 8, right = 8, style }) {
    return (
        <Tooltip
            title={title}
        >
            <InfoRounded 
                fontSize="small" 
                color="info" 
                sx={{ 
                    position: "absolute", 
                    bottom,
                    right,
                    cursor: "pointer",
                    ...style
                }} 
            />
        </Tooltip>
    );
}